import PropTypes from 'prop-types';
import React, { useEffect } from 'react';

import { apiCallStatus, ASSET_TYPES_MS_ID } from 'helpers/constants';
import { LoadingStatusWrapper } from 'sharedComponents';
import { TrendChart } from './TrendChart';
// import { TrendKPIList } from './TrendKPIList';
import { opButtons } from '../../constants';
import { tabIDs } from '../../../constants';
import useReloadTab from '../../useReloadTab';
import InternalTabs from './InternalTabs/InternalTabs';
import { internalTabIDs } from './InternalTabs/constants';

const TrendComponent = ({
    model: {
        activeDetailedInformationTab,
        dateSelection,
        measurementExportLoadingStatus,
        selectedTrendKPIs,
        trendKPIs,
        trendKPIsLoadingStatus,
        trendDataLoadingStatus,
        userLimitsLoadingStatus,
        activeDetailedInformationTabV2,
        limitFromSummary,
        trendKPIsList,
        energyRelatedSignals
    },
    actions: {
        getTrendKPIsForAssetV2,
        reloadAllSelectedTrendKpiData,
        addTrendKPISelectionAction,
        setInternalActiveTab
        // setShowLimitSetting
    },
    activeTab,
    asset,
}) => {

    const refreshData = () => {
        if (trendKPIsLoadingStatus === apiCallStatus.SUCCESS &&
            activeTab === opButtons.trends &&
            (activeDetailedInformationTab === tabIDs.operationalParametersv2 || activeDetailedInformationTabV2 === tabIDs.operationalParameters) &&
            trendKPIs.length &&
            selectedTrendKPIs.length &&
            dateSelection.from &&
            dateSelection.to && !limitFromSummary) {
            reloadAllSelectedTrendKpiData(selectedTrendKPIs);
        }
    };

    useReloadTab(refreshData,
        opButtons.trends,
        [trendKPIsLoadingStatus]);

    useEffect(() => {
        if (trendKPIsLoadingStatus !== apiCallStatus.SUCCESS && trendKPIs?.length === 0) {
            getTrendKPIsForAssetV2(asset);
        }
        // UN-COMMENT FOR SETTING SIGNAL TABLE ON TAB CHANGES WITHIN ASSET
        // return () => {
        //     setShowLimitSetting(false);
        // };
    }, [trendKPIs?.length]);

    const handleKpiClickFromSummary = (kpiKey) => {
        if (!selectedTrendKPIs.includes(kpiKey)) {
            const typeID = ASSET_TYPES_MS_ID[asset?.assetType];
            addTrendKPISelectionAction({
                ...kpiKey,
                assetTypeID: typeID
            });
            reloadAllSelectedTrendKpiData([...selectedTrendKPIs, kpiKey?.timeseriesKey]);
        }
    };

    useEffect(() => {
        if (limitFromSummary && trendKPIsLoadingStatus === apiCallStatus.SUCCESS) {
            if (trendKPIsList?.length > 0) {
                const selectedKpi = trendKPIsList?.find(kpi => kpi.timeseriesKey === limitFromSummary);
                if (selectedKpi) {
                    handleKpiClickFromSummary(selectedKpi);
                    setInternalActiveTab(internalTabIDs.operationalParameters);
                    return;
                }
            }
            if (energyRelatedSignals?.length > 0) {
                const selectedEnergyKpi = energyRelatedSignals?.find(kpi => kpi.timeseriesKey === limitFromSummary);
                if (selectedEnergyKpi) {
                    handleKpiClickFromSummary(selectedEnergyKpi);
                    setInternalActiveTab(internalTabIDs.energyRelatedSignals);
                    return;
                }
            }
        }
    }, [limitFromSummary, trendKPIsLoadingStatus]);

    return (
        <LoadingStatusWrapper
            useCustomAnchor
            transparent
            indicatorConfig={{ placement: 'sticky' }}
            loadingStatus={[
                trendKPIsLoadingStatus,
                measurementExportLoadingStatus,
                trendDataLoadingStatus,
                userLimitsLoadingStatus
            ]}
        >
            <TrendChart asset={asset} />
            {/* Only render InternalTabs after KPIs are loaded to ensure correct signal counts */}
            {trendKPIsLoadingStatus === apiCallStatus.SUCCESS && <InternalTabs />}
            {/* <TrendKPIList asset={asset} /> */}
        </LoadingStatusWrapper>
    );
};

const timeseriesKpiShape = PropTypes.shape({
    timeseriesKey: PropTypes.string,
});

TrendComponent.propTypes = {
    actions: PropTypes.shape({
        getTrendKPIsForAssetV2: PropTypes.func,
        reloadAllSelectedTrendKpiData: PropTypes.func,
        addTrendKPISelectionAction: PropTypes.func,
        setClickedLimitFromSummary: PropTypes.func,
        setInternalActiveTab: PropTypes.func,
    }),
    model: PropTypes.shape({
        activeDetailedInformationTab: PropTypes.string,
        activeDetailedInformationTabV2: PropTypes.string,
        dateSelection: PropTypes.shape({
            from: PropTypes.string,
            to: PropTypes.string
        }),
        trendKPIs: PropTypes.arrayOf(PropTypes.object),
        trendKPIsLoadingStatus: PropTypes.string,
        measurementExportLoadingStatus: PropTypes.string,
        trendDataLoadingStatus: PropTypes.string,
        userLimitsLoadingStatus: PropTypes.string,
        selectedTrendKPIs: PropTypes.arrayOf(PropTypes.object),
        trendKPIsList: PropTypes.arrayOf(timeseriesKpiShape),
        energyRelatedSignals: PropTypes.arrayOf(timeseriesKpiShape),
        limitFromSummary: PropTypes.string
    }),
    activeTab: PropTypes.string,
    asset: PropTypes.object,
};

export default TrendComponent;
